import React from 'react'

const CallerLogs = () => {
  return (
    <div>
      Caller logs
    </div>
  )
}

export default CallerLogs
